import * as THREE from 'three';
import { pando3D } from './setup';
import { spriteText } from './spriteText';
import { MATERIAL } from './material';

export const TRUCK = {
  draw3D: (data) => {
    pando3D.data = data;
    pando3D.containerVectors = pando3D.data.truck;
    pando3D.containerVectors.XOffset = pando3D.containerVectors.width / 2;
    pando3D.containerVectors.ZOffset = -(pando3D.containerVectors.length / 2);

    THREE.Object3D.DefaultUp = new THREE.Vector3(0, 1, 0);
    pando3D.initialize(); // INITIALIZE VARIABLE
    TRUCK.drawBackground(); // SET BACKGROUND
    TRUCK.drawXZFloor();
    TRUCK.drawXYFloor();
    TRUCK.drawGridLines();
    pando3D.animate();
    MATERIAL.load(); // LOAD MATERIAL FROM API DATA
  },

  drawBackground: () => {
    const skyBoxGeometry = new THREE.BoxGeometry(10000, 10000, 10000);
    const skyBoxMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, side: THREE.BackSide });
    const skyBox = new THREE.Mesh(skyBoxGeometry, skyBoxMaterial);
    pando3D.scene.add(skyBox);
    pando3D.animate();
  },

  drawXZFloor: () => {
    // FLOOR COLOR
    const floorMaterial = new THREE.MeshBasicMaterial({
      color: 0x444444,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.5,
    });

    const floorGeometry = new THREE.PlaneBufferGeometry(
      pando3D.containerVectors.width,
      pando3D.containerVectors.length,
      1,
      1,
    );

    const floor = new THREE.Mesh(floorGeometry, floorMaterial);
    floor.rotation.x = Math.PI / 2;
    pando3D.scene.add(floor);
  },

  drawXYFloor: () => {
    // FLOOR COLOR
    const floorMaterial = new THREE.MeshBasicMaterial({
      color: 0x444444,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.5,
    });
    const floorGeometry = new THREE.PlaneBufferGeometry(
      pando3D.containerVectors.width,
      pando3D.containerVectors.height,
      1,
    );

    const floor = new THREE.Mesh(floorGeometry, floorMaterial);
    floor.position.z = pando3D.containerVectors.ZOffset;
    floor.position.y = pando3D.containerVectors.height / 2;

    pando3D.scene.add(floor);
  },

  drawPoints: () => {
    const equipmentSpaceMaker = 50;
    const equipmentSpaceColor = { r: 255, g: 180, b: 100 };

    for (let i = 0; i < pando3D.containerVectors.length; i += equipmentSpaceMaker) {
      // SPRITE FONT SIZE & COLOR
      const spritey = spriteText.draw(` ${i} `, {
        fontsize: 32,
        backgroundColor: {
          r: equipmentSpaceColor.r,
          g: equipmentSpaceColor.g,
          b: equipmentSpaceColor.b,
          a: 1,
        },
      });

      // POSITION OF SPRITE TEXT: x, y, z
      spritey.position.set(
        -pando3D.containerVectors.XOffset - 50,
        -5,
        i + pando3D.containerVectors.ZOffset + equipmentSpaceMaker,
      );
      pando3D.scene.add(spritey);
    }
    pando3D.animate();
  },

  drawGridLines: () => {
    // GRID COLOR
    const gridmaterial = new THREE.LineBasicMaterial({
      color: 0x696969,
      opacity: 1,
      side: THREE.DoubleSide,
    });
    const points = [];
    const heightSpaceLines = TRUCK.splitEqually(
      pando3D.containerVectors.height,
      5,
    );
    const lengthSpaceLines = TRUCK.splitEqually(
      pando3D.containerVectors.length,
      5,
    );

    // ----- START YZ AXIS -----
    for (let i = 0; i < heightSpaceLines.length; i += 1) {
      points.push(
        new THREE.Vector3(
          -pando3D.containerVectors.XOffset - 5,
          heightSpaceLines[i],
          -pando3D.containerVectors.ZOffset,
        ),
      );
      points.push(
        new THREE.Vector3(
          -pando3D.containerVectors.XOffset - 5,
          heightSpaceLines[i],
          pando3D.containerVectors.ZOffset,
        ),
      );
    }

    for (let i = 0; i < lengthSpaceLines.length; i += 1) {
      const current = lengthSpaceLines[i];
      points.push(
        new THREE.Vector3(
          -pando3D.containerVectors.XOffset - 5,
          pando3D.containerVectors.height,
          current + pando3D.containerVectors.ZOffset,
        ),
      );
      points.push(
        new THREE.Vector3(
          -pando3D.containerVectors.XOffset - 5,
          0,
          current + pando3D.containerVectors.ZOffset,
        ),
      );

      // POSITION TEXT MORE THAN TWO DIGIT
      const len = i.toString().length;
      let position = 0;
      if (len === 1) {
        position = -10;
      } else if (len > 1) {
        position = -20;
      }

      let spritey = spriteText.draw(` ${current} `);
      spritey.position.set(
        -pando3D.containerVectors.XOffset - 50,
        -5,
        pando3D.containerVectors.ZOffset + current + position,
      );
      pando3D.scene.add(spritey);

      spritey = spriteText.draw(` ${current} `);
      spritey.position.set(
        pando3D.containerVectors.width,
        -5,
        pando3D.containerVectors.ZOffset + current + position,
      );
      pando3D.scene.add(spritey);
    }

    const gridgeo = new THREE.BufferGeometry().setFromPoints(points);

    const gridlines = new THREE.LineSegments(
      gridgeo,
      gridmaterial,
      THREE.LinePieces,
    );
    pando3D.scene.add(gridlines);
  },

  splitEqually: (total, split) => {
    const divide = total / split;
    const rounded = Math.ceil(divide / split) * split;
    const list = [0];
    for (let i = 0; i < split - 1; i += 1) {
      list.push(rounded);
    }
    list.push(total - rounded * (split - 1));
    return list.map((s => a => (s += a))(0));
  },
};

export default { TRUCK };
